export const postRelationships = [
    'none',
    'local',
    'audience',
    'mentioned',
    'attendee',
    'collaborator',
];
export const defaultGroupRoles = [
    'member',
    'moderator',
    'admin',
    'owner',
];
export const groupRelationships = [
    ...defaultGroupRoles,
    'none',
    'local',
    'invited',
];
export const profileRelationships = [
    'none',
    'local',
    'self',
    'following',
    'followed-by',
    'blocked',
    'blocked-by',
    'muted-by',
];
export const reportRelationships = [
    'none',
    'local',
    'reporter',
    'reported',
    'acted-on',
];
export const accessTokenRelationships = ['none', 'local', 'owner'];
export const postCapabilities = [
    'core-posts-read',
    'core-posts-update',
    'core-posts-delete',
    'core-posts-vote',
    'core-posts-react',
    'core-posts-rsvp',
    'core-posts-reply',
    'core-posts-jam-moderate',
    'core-posts-jam-speak',
    'core-posts-jam-read',
];
export const groupCapabilities = [
    'core-groups-read',
    'core-groups-update',
    'core-groups-updateCapabilities',
    'core-groups-delete',
    'core-groups-join',
    'core-groups-leave',
    'core-groups-addMember',
    'core-groups-removeMember',
    'core-groups-changeMemberRole',
    'core-posts-create-note',
    'core-posts-create-event',
    'core-posts-create-poll',
    'core-posts-create-article',
    'core-posts-create-resource',
];
/** Caps an owner can toggle per relationship in the group editor. */
export const groupCapabilityEditorKeys = [
    ...groupCapabilities,
    'core-posts-read',
    'core-posts-delete',
    'core-posts-react',
    'core-posts-reply',
    'core-posts-rsvp',
    'core-posts-vote',
    'core-posts-create-*',
    'core-posts-*',
    'core-groups-*',
];
/** Owner is omitted — `*` / `core-groups-*` already grants every editor cap. */
export const groupCapabilityEditorRelationships = [
    'none',
    'local',
    'member',
    'moderator',
    'admin',
];
/** Explicit admin list — `core-groups-*` would also grant delete and cap edits. */
export const defaultGroupAdminCapabilityAdds = [
    'core-posts-*',
    'core-groups-read',
    'core-groups-update',
    'core-groups-join',
    'core-groups-leave',
    'core-groups-addMember',
    'core-groups-removeMember',
    'core-groups-changeMemberRole',
];
export const defaultGroupOwnerCapabilityAdds = [
    'core-posts-*',
    'core-groups-*',
];
export const profileCapabilities = [
    'core-profiles-read',
    'core-profiles-update',
    'core-profiles-delete',
    'core-profiles-requestFollow',
    'core-profiles-follow',
    'core-profiles-unfollow',
    'core-profiles-block',
    'core-profiles-unblock',
    'core-profiles-mute',
    'core-profiles-unmute',
];
export const reportCapabilities = [
    'core-reports-create',
    'core-reports-read',
];
export const accessTokenCapabilities = [
    'core-serviceTokens-create',
    'core-serviceTokens-read',
    'core-serviceTokens-delete',
];
export const roleCapabilities = [
    'core-local',
    'core-accounts-read',
    'core-accounts-create',
    'core-accounts-update',
    'core-accounts-delete',
    'core-reports-create',
    'core-reports-update',
    'core-groups-create',
    'core-groups-read',
    'core-groups-delete',
    'core-groups-addMember',
    'core-groups-removeMember',
    'core-groups-changeMemberRole',
    'core-posts-create-note-local',
    'core-posts-create-note-public',
    'core-posts-create-note-direct',
    'core-posts-create-note-private',
    'core-posts-create-event-local',
    'core-posts-create-event-public',
    'core-posts-create-event-direct',
    'core-posts-create-event-private',
    'core-posts-create-poll-local',
    'core-posts-create-poll-public',
    'core-posts-create-poll-direct',
    'core-posts-create-poll-private',
    'core-posts-create-article-local',
    'core-posts-create-article-public',
    'core-posts-create-article-direct',
    'core-posts-create-article-private',
    'core-posts-create-resource-local',
    'core-posts-create-resource-public',
    'core-posts-create-resource-direct',
    'core-posts-create-resource-private',
    'core-posts-read-local',
    'core-posts-announce',
    'core-posts-delete',
    'core-profiles-read',
    'core-profiles-roles-update',
    'core-profiles-delete',
    'core-profiles-suspend',
    'core-profiles-update',
    'core-profiles-impersonate',
    'core-analytics-read',
    'core-config-update',
    'core-config-read',
    'core-customization-read',
    'core-customization-update',
    'core-capabilities-read',
    'core-capabilities-update',
    'core-backups-create',
    'core-backups-read',
    'core-backups-download',
    'core-backups-restore',
    'core-db-access',
    'core-i18n-update',
    'core-logs-read',
    'core-roles-read',
    'core-roles-update',
    'core-maintenance-restart',
    'core-media-read',
    'core-media-delete',
    'core-inviteLinks-create',
    'core-inviteLinks-read',
    'core-inviteLinks-update',
    'core-inviteLinks-delete',
    'core-serviceTokens-create',
    'core-serviceTokens-read',
    'core-serviceTokens-update',
    'core-serviceTokens-delete',
    'core-plugins-manage',
];
/**
 * Capability keys an instance admin can toggle for each role (leaves) plus the
 * wildcard allow-all keys an editor exposes. `*` covers capabilities that do not
 * fall under a `core-<domain>-*` category (e.g. `core-local`).
 */
export const roleCapabilityEditorKeys = [
    ...roleCapabilities,
    '*',
    'core-accounts-*',
    'core-analytics-*',
    'core-backups-*',
    'core-capabilities-*',
    'core-config-*',
    'core-customization-*',
    'core-db-*',
    'core-groups-*',
    'core-i18n-*',
    'core-inviteLinks-*',
    'core-logs-*',
    'core-maintenance-*',
    'core-media-*',
    'core-plugins-*',
    'core-profiles-*',
    'core-posts-create-*',
    'core-posts-*',
    'core-reports-*',
    'core-roles-*',
    'core-serviceTokens-*',
];
/** Capability keys an admin can toggle per relationship for posts. */
export const postCapabilityEditorKeys = [
    ...postCapabilities,
    'core-posts-*',
];
/** Capability keys an admin can toggle per relationship for profiles. */
export const profileCapabilityEditorKeys = [
    ...profileCapabilities,
    ...postCapabilities,
    'core-profiles-*',
    'core-posts-*',
];
/** Capability keys an admin can toggle per relationship for reports. */
export const reportCapabilityEditorKeys = [
    ...reportCapabilities,
    'core-reports-*',
];
/** Capability keys an admin can toggle per relationship for access tokens. */
export const accessTokenCapabilityEditorKeys = [
    ...accessTokenCapabilities,
    'core-serviceTokens-*',
];
